import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, of, concat } from 'rxjs';
import * as BulkApi from '../../../store/bulk/bulk.api';
import * as JobPipelineActions from '../../../store/job-pipeline/job-pipeline.actions';
import Global from '../../../store/global-selectors';
import { BULK_PRINT_PIPELINE } from '../../../job-pipelines/bulk-print/bulk-print-pipeline';
import * as Actions from './bulk.print.actions';
import { trackBulkLabelPrintingComplete } from '../../../store/labels/tracking-events';

export const startBulkPurchase = (action$) => {
  return action$.pipe(
    ofType(Actions.BULK_PRINT_START),
    mergeMap((action) => {
      const { fulfillmentPlanIds = [] } = {
        fulfillmentPlanIds: action.fulfillmentPlanIds,
      };
      return of(
        JobPipelineActions.startJobPipeline(BULK_PRINT_PIPELINE, {
          fulfillmentPlanIds,
          batchId: action.labelBatchId,
        }),
      );
    }),
  );
};

export const startActiveLabelCheck = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.BULK_PRINT_ACTIVE_LABEL_CHECK_START),
    mergeMap(({ jobId }) => {
      const state = getState();
      const { fulfillmentPlanIds } = Global.selectJobPipelineJobDataByJobId(state, { jobId });

      return BulkApi.canPurchaseLabel(fulfillmentPlanIds).pipe(
        mergeMap((data) => {
          return concat(
            of(
              JobPipelineActions.updateJob(jobId, {
                activeLabelStatusList: data,
              }),
            ),
            of(JobPipelineActions.goForwardOnJob(jobId)),
          );
        }),
        catchError(() => {
          return of(JobPipelineActions.exitJobPipeline(jobId));
        }),
      );
    }),
  );
};

export const getLabelPrintedStatus = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.BULK_PRINT_GET_LABEL_PRINTED_STATUS),
    mergeMap(({ jobId }) => {
      const state = getState();
      const { fulfillmentPlanIds, planIdsWithNoLabel } = Global.selectJobPipelineJobDataByJobId(state, { jobId });
      return BulkApi.getLabelPrintedStatusOfFulfillmentPlans(fulfillmentPlanIds.filter((id) => !planIdsWithNoLabel.includes(id))).pipe(
        mergeMap((data) => {
          const printedFulfillmentPlanIds = data.filter((fp) => fp.isPrinted).map((fp) => fp.fulfillmentPlanId);
          trackBulkLabelPrintingComplete(printedFulfillmentPlanIds);
          return concat(
            of(
              JobPipelineActions.updateJob(jobId, {
                printedFulfillmentPlanIds,
              }),
            ),
            of(JobPipelineActions.goForwardOnJob(jobId)),
          );
        }),
      );
    }),
  );
};

export const startPrintFlow = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.BULK_PRINT_EXECUTE_PRINT),
    mergeMap(({ jobId }) => {
      const state = getState();
      const jobData = Global.selectJobPipelineJobDataByJobId(state, { jobId });
      const { idsToPrint } = jobData;

      return BulkApi.fulfillmentPlanToFulfillment(idsToPrint).pipe(
        mergeMap((data = []) => {
          const dataLookupHash = data.reduce((acc, datum) => {
            return {
              ...acc,
              [datum.fulfillmentPlanId]: datum,
            };
          }, {});
          const orderGridIds = Global.selectOrdersGridOrders(state);
          const sortedFulfillmentIds = orderGridIds.reduce((acc, curr) => {
            if (dataLookupHash[curr]) {
              acc.push(dataLookupHash[curr].fulfillmentId);
            }
            return acc;
          }, []);
          return concat(
            of(
              JobPipelineActions.updateJob(jobId, {
                fulfillmentIds: sortedFulfillmentIds,
              }),
            ),
            of(JobPipelineActions.goForwardOnJob(jobId)),
          );
        }),
        catchError(() => of(JobPipelineActions.exitJobPipeline(jobId))),
      );
    }),
  );
};

export const endBulkPrint = (action$) => {
  return action$.pipe(
    ofType(Actions.BULK_PRINT_END),
    mergeMap(() => {
      return EMPTY;
    }),
  );
};
